"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleInputSearch = exports.StyleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _text = _interopRequireDefault(require("webmotors-react-pj/webinput/text"));
const StyleInputSearch = exports.StyleInputSearch = (0, _styledComponents.default)(_text.default).withConfig({
  displayName: "StyleInputSearch",
  componentId: "sc-1khea6i-0"
})(["width:100%;"]);
const StyleContainer = exports.StyleContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleContainer",
  componentId: "sc-1khea6i-1"
})(["#descriptionMessageText{margin-bottom:0;}"]);